// @ts-ignore legacy-hubspot-bender-context is a virtual, undeclared module
import { bender } from 'legacy-hubspot-bender-context';
const {
  staticDomainPrefix
} = bender;
export const getImageUrl = path => `${staticDomainPrefix}/academy-common-lib/static-1.15304/images/${path}`;